module.exports = __webpack_public_path__ + "static/media/egg.3d72d4e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/uncomp/egg.png
// module id = 46
// module chunks = 0